<template>
  <div id="app">
    <Navbar v-if="$route.meta && !$route.meta.noNavBar" />
    <router-view/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

export default {
  name: 'App',
  components: {
    Navbar,
  },
};
</script>


<style src="./styles/style.scss" lang="scss"></style>
